import { Container, Divider, Typography } from '@mui/material'
import React from 'react'

export default function InternalHome(props) {


    return (
        <Container sx={{paddingBlock:2}}>
            <Typography variant='h3'>Introduction to the Blitz Third Party API Documentation</Typography>
            <Divider></Divider>
            <br />
            Welcome to the Internal Developer Documentation! <br />
            This guide provides all the necessary information to understand the Blitz platform and develop it.
        </Container>
    )
}
